import { render, staticRenderFns } from "./ComponentTwo.vue?vue&type=template&id=763a9840&"
import script from "./ComponentTwo.vue?vue&type=script&lang=js&"
export * from "./ComponentTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports